import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getPartnerDateOfBirth } from "reducers/userInfo"
import moment from "moment"
import { updatePartnerDateOfBirth } from "actions/userActions"
import { FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { Label, Spacer } from "../../atoms/Atoms"
import { FleLinkWrapper } from "../../atoms/Links"
import L10n from "../../../../lib/carrot-l10n"
import { FormDateOfBirthInput } from "components/views/atoms/forms/FormDateOfBirthInput"
import { TopSection } from "../TopSection"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const PartnerDateOfBirth = ({ next, history }) => {
  const [partnerDateOfBirth, setPartnerDateOfBirth] = useState(null)
  const [validPartnerDateOfBirth, setValidPartnerDateOfBirth] = useState(true)
  const ref = useRef()
  const previousPartnerDateOfBirth = useSelector((state) => getPartnerDateOfBirth(state))
  const dispatch = useDispatch()

  useEffect(() => {
    if (previousPartnerDateOfBirth != null) {
      setPartnerDateOfBirth(moment(previousPartnerDateOfBirth))
    }
  }, [previousPartnerDateOfBirth])

  const validateAndUpdateDateOfBirth = async () => {
    const dobInputIsValid = ref.current.validate()
    setValidPartnerDateOfBirth(dobInputIsValid)
    if (dobInputIsValid) {
      const partnerDobMoment = ref.current.getMoment()
      await dispatch(updatePartnerDateOfBirth(partnerDobMoment.format("YYYY-MM-DD"), null))
      history.push(next)
    }
  }

  return (
    <FleLayout>
      <TopSection progressStep={3} leftOrBackArrow={<BackArrow />} />
      <SwitchH2ToBodyLarge>{l`When was you partner born?`}</SwitchH2ToBodyLarge>
      <Spacer height={3} />
      <div className="flex flex-row">
        <div className="flex-auto" style={{ flexBasis: 0 }}>
          <Label htmlFor="dateOfBirth" valid={validPartnerDateOfBirth}>
            Month
          </Label>
        </div>
        <Spacer width={1} />
        <div className="flex-auto" style={{ flexBasis: 0 }}>
          <Label htmlFor="dateOfBirth" valid={validPartnerDateOfBirth}>
            Day
          </Label>
        </div>
        <Spacer width={1} />
        <div className="flex-auto" style={{ flexBasis: 0 }}>
          <Label htmlFor="dateOfBirth" valid={validPartnerDateOfBirth}>
            Year
          </Label>
        </div>
      </div>
      <Spacer height={0.5} />
      <FormDateOfBirthInput dateOfBirth={partnerDateOfBirth} ref={ref} />
      <FleLinkWrapper>
        <ContinueArrow onClick={validateAndUpdateDateOfBirth} />
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { PartnerDateOfBirth }
